import { RestrictionConverter } from './restrictionConverter';
export const convertToNavigationRestriction = (properties) => {
    var _a;
    return RestrictionConverter.fromServerModel((_a = properties === null || properties === void 0 ? void 0 : properties.navigation) !== null && _a !== void 0 ? _a : null);
};
export const convertToNavigationRestrictionWithAutoProgress = (properties) => {
    var _a;
    return RestrictionConverter.fromServerModel((_a = properties === null || properties === void 0 ? void 0 : properties.navigation) !== null && _a !== void 0 ? _a : null);
};
